import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as OrderIcon } from "images/icons/cart-shopping.svg"
import { PermissionGroups } from "../constants"

const Orders = lazy(() => import("views/Orders/Orders").then(m => ({ default: m.Orders })))
const ShowOrders = lazy(() => import("views/Orders/OrderViews/ShowOrders").then(m => ({ default: m.ShowOrders })))
const ViewOrder = lazy(() => import("views/Orders/OrderViews/ViewOrder").then(m => ({ default: m.ViewOrder })))
const CreateOrder = lazy(() => import("views/Orders/CreateOrder/CreateOrder").then(m => ({ default: m.CreateOrder })))
const CloneOrder = lazy(() => import("views/Orders/CreateOrder/CloneOrder").then(m => ({ default: m.CloneOrder })))
const ManageOrder = lazy(() => import("views/Orders/ManageOrder/ManageOrder"))

export const orderRoutes: Common.Views = [
  {
    element: <Orders />,
    path: "/orders",
    title: "Orders",
    icon: OrderIcon,
    sortOrder: 4,
    requiredGroups: PermissionGroups.orders.read,
    children: [
      {
        element: <ShowOrders />,
        path: "/orders/",
        title: "Orders",
        parentPath: "/orders",
        section: "Order"
      },
      {
        element: <ViewOrder />,
        path: "/orders/:id",
        title: "Order",
        parentPath: "/orders"
      },
      {
        element: <CreateOrder />,
        path: "/orders/create-order",
        title: "Create order",
        parentPath: "/orders",
        section: "Create order",
        requiredGroups: PermissionGroups.orders.write
      },
      {
        element: <CloneOrder />,
        path: "/orders/create-order-from-existing-order/:id?",
        title: "Create order",
        parentPath: "/orders",
        requiredGroups: PermissionGroups.orders.write
      },
      {
        element: <ManageOrder />,
        path: "/orders/manage-order/:id?",
        title: "Manage order",
        parentPath: "/orders",
        requiredGroups: PermissionGroups.orders.write
      }
    ]
  },
]
